import Cookies from 'js-cookie';

// Helper function to hash content
async function hashContent(content: string): Promise<string> {
    const encoder = new TextEncoder();
    const data = encoder.encode(content);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hashBuffer))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
}

// Function to handle alerts
async function handleGlobalAlerts(): Promise<void> {
    const alerts = document.querySelectorAll<HTMLDivElement>('.alert-global');
    const currentHashes = new Set<string>();  // Store current alert hashes

    for (let alert of alerts) {
        const content = alert.textContent?.trim() ?? "";
        const hash = await hashContent(content);
        const cookieName = 'remax_global_alert__' + hash;
        currentHashes.add(cookieName);  // Add to set of current hashes

        // Alerts are defaulted to hidden, manage display based on cookie
        if (Cookies.get(cookieName)) {
            alert.style.display = 'none'; // Ensure it remains hidden
        } else {
            alert.style.display = 'block'; // Show the alert if no cookie is found
            const closeButton = alert.querySelector<HTMLButtonElement>('.close');
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    Cookies.set(cookieName, 'closed', { expires: 30, secure: true, sameSite: 'strict' });
                    alert.style.display = 'none'; // Hide alert and set cookie
                });
            }
        }
    }

    // Clean up outdated cookies
    const allCookies = Cookies.get();
    for (const cookieName in allCookies) {
        if (cookieName.startsWith('remax_global_alert__') && !currentHashes.has(cookieName)) {
            Cookies.remove(cookieName); // Remove cookies that are no longer relevant
        }
    }
}

// Execute when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', handleGlobalAlerts);
